import React from "react";
import {
    AppstoreOutlined,
    TrophyOutlined,
    BellOutlined,
    SafetyCertificateOutlined,
    TeamOutlined,
    ThunderboltOutlined,
} from "@ant-design/icons";
import Reveal from "../../../../components/Reveal";
import { useTranslation } from "../../../../i18n/LanguageContext";
import "./style.css";

const benefits = [
    { icon: <AppstoreOutlined />, id: "allInOne" },
    { icon: <TrophyOutlined />, id: "coins" },
    { icon: <BellOutlined />, id: "notify" },
    { icon: <SafetyCertificateOutlined />, id: "trust" },
    { icon: <TeamOutlined />, id: "community" },
    { icon: <ThunderboltOutlined />, id: "fast" },
];

const Benefits = () => {
    const { t } = useTranslation();
    return (
        <div className="main-content-wrapper">
            <section className="benefits" id="benefits">
                <Reveal className="benefits__head">
                    <span className="section-eyebrow">
                        {t("benefits.eyebrow")}
                    </span>
                    <h2>{t("benefits.heading")}</h2>
                    <p>{t("benefits.sub")}</p>
                </Reveal>

                <div className="benefits__grid">
                    {benefits.map((b, i) => (
                        <Reveal
                            as="article"
                            className="benefit-card"
                            key={b.id}
                            delay={(i % 3) + 1}
                        >
                            <span className="benefit-card__icon">{b.icon}</span>
                            <h3>{t(`benefits.${b.id}.title`)}</h3>
                            <p>{t(`benefits.${b.id}.text`)}</p>
                        </Reveal>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default Benefits;
